import { type Dispatch, type FC, type ReactNode, type SetStateAction } from "react";
import { type ClientImage } from "@clientFrontend/features/publication/components/ClientImageLibraryModal/type";
import { TextButton } from "@root/shared/components/TextButton";
import Modal from "@root/shared/components/Modal";
import { Icon } from "@root/shared/components/Icon";
import { ClientImageCassettes } from "./uiParts/ClientImageCassettes";
import { ImageUploadInfoBox } from "./uiParts/ImageUploadInfoBox";
import * as styles from "./styles.css";

type Props = {
  clientImages: ClientImage[];
  selectedImageIds: number[];
  clientImageUrl: string;
  headerTitle?: string;
  footerContent?: ReactNode;
  setClientImages: Dispatch<SetStateAction<ClientImage[]>>;
  handleClickClientImageCassette: (clientImage: ClientImage) => void;
  handleClearSelectedImages: () => void;
  handleCloseModal: () => void;
};

export const Presentation: FC<Props> = ({
  clientImages,
  selectedImageIds,
  clientImageUrl,
  headerTitle,
  footerContent,
  setClientImages,
  handleClickClientImageCassette,
  handleClearSelectedImages,
  handleCloseModal,
}) => {
  return (
    <Modal
      isShow
      headerTitle={headerTitle ?? "画像ライブラリ"}
      headerTitleStyle="gray"
      footerContentStyle="button"
      onClose={handleCloseModal}
      footerContent={footerContent}
    >
      <div className={styles.modalWrapper}>
        <div className={styles.clientImageCassetesWrapper}>
          <div className={styles.textButtonWrapper}>
            <TextButton
              leftIconName="cross-thin"
              size="large"
              onClick={() => handleClearSelectedImages()}
            >
              すべての選択をリセット
            </TextButton>
          </div>
          {clientImages.length ? (
            <ClientImageCassettes
              selectedImageIds={selectedImageIds}
              clientImages={clientImages}
              handleClickClientImageCassette={handleClickClientImageCassette}
            />
          ) : (
            <div className={styles.noCassetteIcon}>
              <Icon name="picture" fontSize="20px" />
              <span className={styles.noCassetteText}>ここに設定した画像が表示されます</span>
            </div>
          )}
        </div>
        <ImageUploadInfoBox clientImageUrl={clientImageUrl} setClientImages={setClientImages} />
      </div>
    </Modal>
  );
};
